import React, {Component} from "react";
import PriceItem from "../../common/PriceItem";
import CoreService from "../../service/CoreService";

class SubscriptionPlans extends Component {
    constructor() {
        super();

        this.state = {
            currentPlan: {
                active: false,
                name: '',
                description: '',
                priceAmount: 0,
                deploymentLimit: 0
            },
            subscribe: {
                productVisible: false,
                paymentFormVisible: false
            }
        };
    }

    componentDidMount() {
        this.updateState(this.props.subscription);
    }

    componentWillReceiveProps(nextProps) {
        this.updateState(nextProps.subscription);
    }

    updateState = (update) => {
        if (update.currentPlan) {
            this.setState({
                currentPlan: update.currentPlan,
            });
        }
        if (update.subscribe) {
            this.setState({
                subscribe: update.subscribe,
            });
        }
    };

    cancelSubscription = () => {
        CoreService.showModal("Cancel Subscription", (
            <span>Please contact us at <a href="mailto:info@gatehillsoftware.com">info@gatehillsoftware.com</a> to cancel your subscription.</span>
        ));
    };

    render() {
        const planFeatures = [];

        if (this.state.currentPlan.active) {
            planFeatures.push(
                <span><strong>{this.state.currentPlan.deploymentLimit}</strong> monthly deployments</span>
            );

            if (this.state.currentPlan.priceAmount === 0) {
                planFeatures.push(
                    <span className="text-muted">no build history</span>,
                    <span className="text-muted">no logs</span>
                )
            } else {
                planFeatures.push(
                    <span><strong>history</strong> of your builds</span>,
                    <span><strong>logs</strong> in real-time</span>
                )
            }
        }

        return (
            <div className="row m-t">
                {!this.state.currentPlan.active &&
                    <div className="col-sm-6 col-md-5">
                        <div className="panel panel-default">
                            <div className="panel-heading">
                                <h3 className="panel-title">Loading Subscription</h3>
                            </div>
                            <div className="panel-body text-center p-b-md" style={{height: 360}}>
                                <h1 className="text-muted icon icon-circular-graph"/>
                                <div className="text-muted m-t-sm">Loading subscription details</div>
                            </div>
                        </div>
                    </div>}

                {this.state.currentPlan.active &&
                    <div className="col-sm-6 col-md-5">
                        <div className="panel panel-success">
                            <div className="panel-heading">
                                <h3 className="panel-title">Your Active Plan</h3>
                            </div>
                            <div className="panel-body text-center p-b-md">
                                <PriceItem
                                    title={this.state.currentPlan.name}
                                    description={this.state.currentPlan.description}
                                    price={`${this.state.currentPlan.priceAmount}`}
                                    xPadding={false}
                                    yPadding={false}
                                    features={planFeatures}
                                    buttonVisible={this.state.currentPlan.cancellable}
                                    buttonText="Cancel Subscription"
                                    buttonStyle="danger"
                                    onClick={this.cancelSubscription}
                                />
                            </div>
                        </div>
                    </div>}

                {this.state.subscribe.productVisible &&
                    <div className="col-sm-6 col-md-5">
                        <div className="panel panel-primary">
                            <div className="panel-heading">
                                <h3 className="panel-title">Upgrade</h3>
                            </div>
                            <div className="panel-body text-center p-b-md">

                                <PriceItem
                                    title="Individual"
                                    description="The perfect sized plan for a single project."
                                    price="3"
                                    xPadding={false}
                                    yPadding={false}
                                    features={[
                                        <span><strong>100</strong> monthly deployments</span>,
                                        <span><strong>history</strong> of your builds</span>,
                                        <span><strong>logs</strong> in real-time</span>
                                    ]}
                                    buttonText="Upgrade plan"
                                    buttonStyle="primary"
                                    onClick={() => window.location.href = '/subscribe'}
                                />

                            </div>
                        </div>
                    </div>}
            </div>
        );
    }
}

SubscriptionPlans.propTypes = {
    subscription: React.PropTypes.object.isRequired,
};

export default SubscriptionPlans;



// WEBPACK FOOTER //
// ./src/modules/views/product/SubscriptionPlans.js